module.exports = __webpack_public_path__ + "img/alert.a1d59800.svg";